import {CommandStrategy} from './base/CommandStarategy';
import {PieMenuIcons} from '../PieMenuIcons';
import {Card} from '../../../game_table/table_objects/stacks/Card';
import {Stack} from '../../../game_table/table_objects/stacks/Stack';
import MessageHelper from '../../../../../../../../helpers/MessageHelper';
import {TableController} from '../../../../../controllers/silent/TableController';
import {Point} from 'pixi.js';
import {CardSelector} from '../../../../../controllers/CardSelector';

export class PutCardsOnTableCommandStarategy extends CommandStrategy
{
    constructor() {
        super({iconId: PieMenuIcons.TBL, hint: 'Put on\ntable (T)'});
    }

    isApplicable(card: Card | undefined, stack: Stack | undefined): boolean {
        return CardSelector.selectedCards.length > 0 && !stack;
    }

    execute(commandIndex: any): void {
        let cardIds: number[] = CardSelector.selectedCards.map(card => card.activeData.id);
        let tableCenter: Point = TableController.getCenter();
        MessageHelper.sendChangeCardsMessage(MessageHelper.TYPE_MOVE_CARD_TO_TABLE_FROM_HAND, {
            x: tableCenter.x - CardSelector.selectedCards[0].activeData.width / 2,
            y: tableCenter.y - CardSelector.selectedCards[0].activeData.height / 2,
            ids: cardIds
        });
    }
}
